.radioButton {
    border: 1px solid var(--mantine-color-dark-3);

    &[data-checked] {
        border-color: var(--mantine-primary-color-4);
    }
}

.overflow {
    overflow: auto;
    white-space: nowrap;
    flex-wrap: nowrap;
}
